const WhyChooseUsData = [
  {
    icon: "fa-anchor",
    class: "feature_box_col_one",
    title: "Young energetic thought process",
    content:
      "We are a team of developers, designers, writers who want to use their skills for building your dream projects.",
  },
  {
    icon: "fa-globe",
    class: "feature_box_col_two",
    title: "Fully Agile",
    content:
      "We follow agile model on each project which means our client gets every update of the work done and review the product on every starge of decided timeline.",
  },
  {
    icon: "fa-hourglass-half",
    class: "feature_box_col_three",
    title: "On Time Delivery",
    content:
      "We are committed to deliver your dream project within the mutually decided timeline.",
  },
  {
    icon: "fa-globe",
    class: "feature_box_col_four",
    title: "Free Updates and Maintenance",
    content:
      "We provide free updates and monthly maintenace which differs on project basis.",
  },
  {
    icon: "fa-globe",
    class: "feature_box_col_five",
    title: "High-End Quality",
    content: "We deliver you the state of art products in the set time.",
  },
  {
    icon: "fa-database",
    class: "feature_box_col_six",
    title: "Free 24/7 Support",
    content: "You can even reach out to us for support in odd hours.",
  },
];

export { WhyChooseUsData };
